import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.fromList([
	'unknown',
	...constants.job.status.ids,
	...constants.transaction.status.ids,
]);
